import { DownOutlined } from "@ant-design/icons";
import { AutoComplete, Input, Tag, Tooltip } from "antd";
import { useState } from "react";
import styles from "./Search.module.scss";
import FiltersSelectedTags from "../FilterSelectedTags/FilterSelectedTags";

const SelectListFilters = ({
  placeholder,
  options,
  filters,
  setFilters,
  entity,
  style,
  popupMatchSelectWidth,
  tagLength = 15,
  tagReverse = false,
  tagColor = "",
}) => {
  const [query, setQuery] = useState("");

  const tagRender = (label) => {
    const onPreventMouseDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
    const onCloseTag = () => {
      const list = filters[`${entity}`].filter((item) => item !== label);
      setFilters({
        ...filters,
        [`${entity}`]: list.length == 0 ? null : list,
      });
    };
    const isLongTag = label.length > tagLength;
    const tagElem = (
      <Tag
        onMouseDown={onPreventMouseDown}
        closable
        onClose={onCloseTag}
        color={tagColor ? tagColor : ""}
      >
        {isLongTag
          ? tagReverse
            ? `...${label.slice(label.length - tagLength, label.length)}`
            : `${label.slice(0, tagLength)}...`
          : label}
      </Tag>
    );
    return (
      <>{isLongTag ? <Tooltip title={label}>{tagElem}</Tooltip> : tagElem}</>
    );
  };
  const handleInputSearch = (value) => {
    setQuery(value);
  };
  const handleInputConfirm = (value, option) => {
    setFilters({
      ...filters,
      [`${entity}`]: filters[`${entity}`]
        ? [...filters[`${entity}`], value]
        : [value],
    });
    setQuery("");
  };
  const filterOption = (input, option) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());
  return (
    <div className={styles["search-container"]}>
      <AutoComplete
        value={query}
        options={options}
        filterOption={filterOption}
        onSearch={handleInputSearch}
        onSelect={handleInputConfirm}
        popupMatchSelectWidth={popupMatchSelectWidth}
        style={style ? style : { width: "100%" }}
        children={
          <Input
            suffix={<DownOutlined style={{ opacity: 0.5 }} />}
            placeholder={placeholder}
          />
        }
      ></AutoComplete>

      <FiltersSelectedTags
        filters={{ [entity]: filters[entity] }}
        setFilters={setFilters}
      />
    </div>
  );
};

export default SelectListFilters;
